import store from '../../store';

export default async (to, from, next) => {
    if(store.getters['authenticated']){

        if (store.getters['authenticated'] && store.getters['permissions'].includes('update ' + to.name.split('-')[0])){
            next();
        } else {
            await store.dispatch('setErrorModal', true);
            await store.dispatch('setErrorMessage', `You don\'t have permission to edit ${to.name}`);
            next({path: from.path});
        }
    }else{
        next({name: 'login-page'});
    }

}